<template>
      <div class="commonDialog" v-if="isLoginBool">
        <div class="widthPercent100">
          <div  class="commonDialogContent">
            <div class="commonDialogContentHead borderBotE5 backF5">
              <span class="color21 size16 font500">请输入您的联系方式，继续投保</span>
            </div>
            <van-form ref="ruleForm">
              <div class="marLR20 borderBotDfe marTop10">
                <van-field class="color21 iptBackF" icon-prefix="iconfont" left-icon="iconfont iconbangdingshouji color40 size16"
                           v-model="ruleForm.tel" type="digit" maxlength="11" :rules="telRules" name="mobile" placeholder="请输入手机号"/>
              </div>
              <div class="marLR20 marTop10">
                <van-field class="color21 Yflex" icon-prefix="iconfont"
                           left-icon="iconfont iconyanzhengma1 size16 color40"
                           v-model="ruleForm.code" :rules="codeRules" maxlength="6" type="digit"
                           placeholder="请输入验证码">
                  <template #button>
                    <span class="pointer" @click="sendCode1" :class="verfDisabled ? 'color99' : 'color40'">{{verfCont}}</span>
                  </template>
                </van-field>
              </div>
            </van-form>
            <div class="marLR20 marTop30 marBott30">
              <van-button type="primary" @click="loginFn" class="widthPercent100 back40 borderNone">提交</van-button>
            </div>
          </div>
        </div>
      </div>
</template>
<!--
	Created by xieqiang on 2019/12/17.
-->
<script type="es6">
 // import VantForm from './form';
  export default {
    // name: 'test',
    name: 'isLogin',
    data() {
      return {
        isLoginBool: false,
        verftype: 'info',
        verfCont: '获取验证码',
        verfDisabled: false,
        verfBool: null,
        ruleForm: {
          tel: '',   // 手机号码
          code: ''   // 密码
        },
        telRules: [{
          required: true,
          message: '手机号码不能为空',
          trigger: 'onBlur'
        }, {
          // 自定义校验规则
          validator: value => {
            return /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
              .test(value)
          },
          message: '请输入正确格式的手机号码',
          trigger: 'onBlur'
        }],
        codeRules: [{
          required: true,
          message: '验证码不能为空',
          trigger: 'onBlur'
        }]
      }
    },
    watch: {},//监听
    methods: {
      // 登录
      loginFn() {
        this.$refs.ruleForm.validate().then(() => {
          let url = `/login/smsBizLogin`
          this.$http.post(url, this.ruleForm).then(res => {
            console.log('res:', res)
            if (!res) return
            localStorage['token'] = res.data.body
            let backUrl = this.commonJs.delParam('token')
            window.location.href = `${backUrl}&token=${res.data.body}`
          })
        }).catch(() => {
          this.$toast('请填写必要的信息！');
        })
      },
      // 登录发送验证码
      sendCode1() {
        if (this.verfDisabled) return
        this.$refs.ruleForm.validate('mobile').then(() => {
          let url = `/login/sendBizLoginCode`
          this.$http.post(url, this.ruleForm).then(res => {
            if (!res) return
            this.$toast('验证码发送成功！');
            this.time(60)
          })
        }).catch(() => {
          this.$toast('请填写正确手机号！');
        })
      },
      time(w) {
        if (w == 0) {
          this.verfDisabled = false;
          this.verftype = 'info';
          this.verfCont = '获取验证码';
        } else {
          this.verftype = 'info';
          this.verfDisabled = true;
          this.verfCont = "重新发送(" + w + ")";
          w--;
          this.verfBool = setTimeout(() => {
            this.time(w);
          }, 1000)
        }
      },
    },
//    components: {
//      VantForm
//    }
  }
</script>

<style scoped>
  .commonDialog{
    z-index: 99999;
  }
  .bgColor406 {
    background-color: #406cff
  }
  .widthPercent100{
    margin-top:-200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/isLogin.vue